/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterDefinitionEbsBlockDeviceConfig } from './emrClusterDefinitionEbsBlockDeviceConfig';


export interface EmrClusterDefinitionEbsConfiguration { 
    /**
     * An array of Amazon EBS volume specifications attached to a cluster instance
     */
    ebsBlockDeviceConfigs?: Array<EmrClusterDefinitionEbsBlockDeviceConfig>;
    /**
     * Indicates whether an Amazon EBS volume is EBS-optimized
     */
    ebsOptimized?: boolean;
}
